import {
  ERROR_MSG,
  // EVENTS,
  ONCLICK,
  PAGES,
  PAGE_VIEW,
  PAYEE_MANAGEMENT,
  STRINGS,
  PAGES_ADD_BILL,
  PAGES_MANAGE_BILL,
  PAGES_BILL_DISCOVERY,
  PAGES_VERIFY_BILL_DISCOVERY,
  SUBSITESECTION,
  PAGES_VERIFY_BILL_DISCOVERY_ERROR
} from './tealiumData'

const setAttributes = (
  dataSource,
  currentPage,
  subSiteSection,
  events,
  errorMessage,
  payload,
  errorMessageStatus
) => {
  const obj = {}
  const { billerType, accountType, transactionStatus } = payload || {}
  obj.datasource = dataSource
  obj.currentPage = currentPage
  obj.siteSection = PAYEE_MANAGEMENT // site section is always payments
  obj.subSiteSection = subSiteSection
  if (errorMessage) {
    obj.errormessage = `${ERROR_MSG.BASE_ERROR} ${errorMessage}`
  }
  if (events) obj.events = events
  if (billerType) obj.billerType = billerType
  if (accountType) obj.accountType = accountType
  if (transactionStatus) obj.transactionStatus = transactionStatus
  if (errorMessageStatus) obj.errorMessage = errorMessageStatus

  return obj
}

// Add by manual - person,company and add by search
export const getAddbillhome = () =>
  setAttributes(PAGE_VIEW, PAGES.HOME, SUBSITESECTION.HOME)

export const getAddbillpersonmanually = (payload) => {
  let addbilldetails = ''
  if (!payload.adddBySearch) {
    addbilldetails = payload.companyTab
      ? PAGES_ADD_BILL.ENTER_COMPANY_DETAILS
      : PAGES_ADD_BILL.ENTER_PERSON_DETAILS
  } else {
    addbilldetails = PAGES_ADD_BILL.ENTER_COMPANY_DETAILS_BY_SEARCH
  }

  return setAttributes(
    PAGE_VIEW,
    addbilldetails,
    SUBSITESECTION.ADD_BILL,
    '',
    '',
    payload
  )
}

// Edit and delete biller
export const getEditBill = (payload) => {
  const currentPage = !payload.isDelete
    ? PAGES_MANAGE_BILL.EDIT_BILL
    : PAGES_MANAGE_BILL.DELETE_BILL
  return setAttributes(
    PAGE_VIEW,
    currentPage,
    SUBSITESECTION.EDIT_BILL,
    '',
    '',
    payload
  )
}

// consent popup and discovery flow
export const getFinalBillDashboard = (payload) => {
  const { consentPopup, noBills } = payload
  let currentPage = ''

  if (!consentPopup) {
    currentPage = PAGES_BILL_DISCOVERY.FOUND_ASSOCIATED_BILLS
    if (noBills) currentPage = PAGES_BILL_DISCOVERY.NO_BILLS
  } else {
    currentPage = PAGES_BILL_DISCOVERY.CONSENT_POPUP
  }

  return setAttributes(
    PAGE_VIEW,
    currentPage,
    SUBSITESECTION.FIND_MY_BILL,
    '',
    '',
    payload
  )
}

export const getVerifyBillDashboard = (payload = {}) => {
  const { isError, genericError } = payload
  let errorMessage = ''
  let currentPage = PAGES_VERIFY_BILL_DISCOVERY.VERIFY_BILLS
  if (isError) {
    currentPage = PAGES_VERIFY_BILL_DISCOVERY.VERIFICATION_ERROR
    if (genericError) {
      errorMessage = PAGES_VERIFY_BILL_DISCOVERY_ERROR.GENERIC_ERROR
    } else {
      errorMessage = PAGES_VERIFY_BILL_DISCOVERY_ERROR.USER_ERROR
    }
  }

  return setAttributes(
    PAGE_VIEW,
    currentPage,
    SUBSITESECTION.FIND_MY_BILL,
    '',
    '',
    payload,
    errorMessage
  )
}

// events
export const getContactInfo = (payload) => {
  const currentPage = `${PAGES.ENROLLMENT}${payload.pageName} ${STRINGS.POPUP}`
  return setAttributes(ONCLICK, currentPage, SUBSITESECTION.ENROLLMENT)
}
